import * as core from '../../../../../../../core'
import * as proposals from '../proposals'

export const RESOURCE = {
  payload: {
    alias: 'proposal.list',
    appAlias: proposals.RESOURCE.payload.alias,
    description: "Explore Attain's AI-Enabled assets",
    display: {
      isMain: true,
      position: 1,
    },
    name: 'Proposal List',
    page: { alias: 'proposal.list' },
  },
  type: core.quiver.Resource.Type.AppPage,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.AppPage>
